<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">角色菜单管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <form action="" class="form-inline">
                <div class="form-group">
                   <el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">刷新</el-button>
                   <el-button v-if="parentMenuId" class="btn btn-primary" type="primary" size="small" icon="el-icon-back" @click="$router.go(-1)">返回</el-button>
                </div>
            </form>
        </div>
        <div class="content-data" v-if="0 < roleMenus.length">
            <el-table highlight-current-row :data="roleMenus" border>
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column align="center" label="菜单名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="绑定url">
                    <template slot-scope="scope">
                        <span>{{scope.row.bindurl}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="菜单类型">
                    <template slot-scope="scope">
                        <span>{{0==scope.row.menuLevel?'主菜单':'附属菜单'}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="上级菜单">
                    <template slot-scope="scope">
                        <span>{{scope.row.parentName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="菜单级别">
                    <template slot-scope="scope">
                        <span>{{scope.row.menuLevel}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="menus['M9522']" @click="deleteRoleMenu(scope.row.id)" type="danger" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="/menu/pageMenuByRole" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            roleMenus: [],
            query: {
                userRole:'MANAGER',
            },
            roleId:'',

            menus: {},
        }
    },
    created() {
        var _this = this;
        _this.roleId = _this.$route.query.roleId;
        _this.query.roleId = _this.$route.query.roleId;
        _this.menus =_this.$common.cache("menus");
    },
    methods: {
        fillData(_response) {
            var _this = this;
            if(_response.items){
               _this.roleMenus = _response.items;
            }
        },
        submitQuery(_num) {
            var _this = this;
            _this.roleMenus = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteRoleMenu: function(_roleMenuId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: 'roleMenu/deleteRoleMenu',
                    data: {
                        roleMenuId: _roleMenuId
                    },
                    success: function(response) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.$common.authority();
                                _this.submitQuery();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        },
    }
}
</script>
<style scoped>
td {
    text-align: center;
}
.table tr th{
    text-align: center; 
}
</style>